export default __webpack_public_path__ + "static/media/Step3GIF1.21045d07.gif";